import { useEffect } from 'react';
import * as React from 'react';
import SecuredPage from 'Views/Components/Security/SecuredPage';

import { FERRY_SCHEDULE_PAGE_TITLE } from 'ConstantPageNames';
import { store } from 'Models/Store';
import FerrySchedule from 'Modules/FerrySchedule/FerrySchedule';
import MarketingBanner from 'Views/Components/_HumanWritten/MarketingBanner';
import NavigationWrapper from 'Views/Components/Navigation/NavigationWrapper';
import { observer } from 'mobx-react';

export interface FerrySchedulePageProps {}

export function FerrySchedulePage() {
	useEffect(() => {
		document.title = FERRY_SCHEDULE_PAGE_TITLE;
	}, []);

	return (
		<SecuredPage>
			<NavigationWrapper />
			<div className="body-content body-content--ferry-schedule">
				<FerrySchedule />
				<div className="absolute-position">
					{/* <PoweredByFerryHawk light={false} showOnMobile={false} absolute /> */}
					{!store.isManager && <MarketingBanner />}
				</div>
			</div>
		</SecuredPage>
	);
}

export default observer(FerrySchedulePage);
